import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  protected http: HttpClient;
  constructor(http: HttpClient, tokenService: TokenService) {
    this.http = http;

  }

  getMIDetailByAppID(_appID: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetMIDetailByAppID?AppId=${_appID}`);
  }

  //   getAppFarmerId(farmerId: any) {
  //     return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetApplicationsByFarmerID?FarmerID=${farmerId}`);
  // }
  getApplicationByFarmerId(farmerId: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerDashboardDataByFarmerID/${farmerId}`);
  }
  getApplicationForAtalBhujal(atalUserId: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetDashboardDataByAtalUserID/${atalUserId}`);
  }

  GetAllFarmerDetails() {
    return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetAllFarmerDetails`);
  }

  getApplicationByAppId(appId): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}DashBoard/GetViewApplicationByAppID/${appId}`
    );
  }

  getApplicationStatusByAppId(appId): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}DashBoard/GetAppIDTrackerStatus?AppId=${appId}`, { responseType: 'text' }
    );
  }

  getExistingMIDetails(appId): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}DashBoard/GetExistingMIDetails?AppId=${appId}`
    );
  }

  deleteFarmerApplicationByAppId(appId): Observable<any> {
    return this.http.delete(
      `${environment.apiUrl}FarmerApplication/DeleteFarmerApplication?appID=${appId}`
    );
  }

  getApplicationByAtal(AtalId: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetDashboardDataByAtalUserID/${AtalId}`);
  }

  requestSolar(reqBody) {
    return this.http.post(`${environment.apiUrl}data/requestsolar_enc`, reqBody);
  }


  solarProcedure(reqBody) {
    return this.http.post(`${environment.apiUrl}data/solarproc_enc`, reqBody);
  }

  addToSolarFlow(reqBody) {
    return this.http.post(`${environment.apiUrl}data/addtosolarflow_enc`, reqBody);
  }

  modifySolarFlow(reqBody) {
    return this.http.post(`${environment.apiUrl}data/modifysolar_enc`, reqBody);
  }

  getSolar(reqBody) {
    return this.http.post(`${environment.apiUrl}data/getsolar`, reqBody);
  }

  solarList(reqBody) {
    return this.http.post(`${environment.apiUrl}data/solarList`, reqBody);
  }

  getLandGetAreaByKhewatDevOnly() {
    return this.http.post(`${environment.apiUrl}LandDetails/GetLandGetAreaByKhewatDevOnly`, {});
  }


  solarBackup(value): Observable<any> {
    return this.http.post(`${environment.apiUrl}data/solarBackup?fileBackup=${value}`, {});
  }

  removedbbackup(reqBody) {
    return this.http.post(`${environment.apiUrl}data/removedbbackup`, reqBody);
  }

  downloadsolar(reqBody) {
    return this.http.post(`${environment.apiUrl}data/downloadsolar`, reqBody);
  }

  getErrorTracking() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetErrorTracking`);
  }

  UpdateActivityTracker(reqBody) {
    return this.http.post(`${environment.apiUrl}Department/UpdateActivityTracker?AutoId=${reqBody.AutoId}&StatusType=${reqBody.StatusType}&Status=${reqBody.Status}`, reqBody);
  }

  pendingReportService(apiName, userId, appType, financialyear, AppCount) {
    return this.http.get<any>(`${environment.apiUrl}${apiName}?UserId=${userId}&AppType=${appType}&financialyear=${financialyear}&AppCount=${AppCount}`);
  }

}
